import { EMPTY_OBJECT } from '../../../constants/common'
import { ButtonSelect } from '../../Select'

import { YEAR_MONTH_SELECT_DROPDOWN_MAX_HEIGHT } from './MonthYearSelect.constants'

import * as styles from './MonthYearSelect.module.css'

/**
 * The {@link MonthYearSelect} component represents the common {@link Select}
 * component for {@link MonthSelect} and {@link YearSelect}
 */
function MonthYearSelect({
  Select = ButtonSelect,
  borderless = false,
  className = styles.MonthYearSelect,
  controlProps: {
    indicatorsProps: { ButtonClear = null, ...indicatorsProps } = EMPTY_OBJECT,
    ...controlProps
  } = EMPTY_OBJECT,
  disabled,
  dropdownFloatingConfig: {
    dropdownStyles: {
      maxHeight: dropdownMaxHeight = YEAR_MONTH_SELECT_DROPDOWN_MAX_HEIGHT,
      ...dropdownStyles
    } = EMPTY_OBJECT,
    maxWidthByRef = false,
    ...dropdownFloatingConfig
  } = EMPTY_OBJECT,
  options,
  size,
  ...selectProps
}) {
  return (
    <Select
      {...selectProps}
      className={className}
      controlProps={{
        ...controlProps,
        borderless,
        height: size,
        indicatorsProps: {
          ...indicatorsProps,
          ButtonClear,
        },
      }}
      disabled={options.length === 0 || disabled}
      dropdownFloatingConfig={{
        ...dropdownFloatingConfig,
        dropdownStyles: { ...dropdownStyles, maxHeight: dropdownMaxHeight },
        maxWidthByRef,
      }}
      options={options}
    />
  )
}

export default MonthYearSelect
